import { createFileRoute } from '@tanstack/react-router';

import { QuickCalcPage } from '../../../../features/sales/ui/quick-calc-page.tsx';
import { requirePermissionRoute } from '../../../../lib/permissions.ts';

export const Route = createFileRoute('/_app/sales/deals/$id_/quick')({
  beforeLoad: requirePermissionRoute('sales.use'),
  component: QuickRoute,
});

/** «Быстрый расчёт» сделки на всю страницу: `/sales/deals/<id>/quick`. */
function QuickRoute() {
  const { id } = Route.useParams();
  return <QuickCalcPage dealId={id} />;
}
